import { activeEventApiUrl, eventsApiUrl, nonce } from '../utils/runtime';

function withQuery(url, params = {}) {
  const nextUrl = new URL(url, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      nextUrl.searchParams.set(key, String(value));
    }
  });

  return nextUrl.toString();
}

async function requestJson(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: {
      Accept: 'application/json',
      ...(nonce ? { 'X-WP-Nonce': nonce } : {}),
      ...(options.headers || {}),
    },
  });

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.message || 'Event-Daten konnten nicht geladen werden.');
  }

  return payload;
}

export function fetchActiveEvent({ latitude = null, longitude = null } = {}) {
  return requestJson(withQuery(activeEventApiUrl, { lat: latitude, lng: longitude }));
}

export function fetchEvents(params = {}) {
  return requestJson(withQuery(eventsApiUrl, params));
}

export function fetchEvent(eventIdentifier) {
  return requestJson(`${eventsApiUrl}/${encodeURIComponent(eventIdentifier)}`);
}

export function fetchEventLeaderboard(eventId, { limit = 25 } = {}) {
  return requestJson(withQuery(`${eventsApiUrl}/${eventId}/leaderboard`, { limit }));
}

export function fetchEventStats(eventId) {
  return requestJson(`${eventsApiUrl}/${eventId}/stats`);
}

export function joinEvent(eventId, eventCode = '') {
  return requestJson(`${eventsApiUrl}/${eventId}/join`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ event_code: eventCode }),
  });
}
